<template>
    <div>
        <h1 class='text-secondary mb-5'>{{ section.name }}</h1>

        <div class="d-flex flex-wrap" style="max-width: 900px;">
            <p style="width:300px;" class="border-gray-300 border-start border-4 ps-2 my-4" v-for="skill in datas.skills">

                <b :class="'text-'+skill.class">{{ skill.title }}</b>

                <div class="mt-2">
                    <div v-for="subskill in skill.subskills" class="d-flex">
                        <div style="width:35px;">
                            <i :class="[subskill.icon, 'text-'+skill.class]" class=""></i>
                        </div>
                        <div>
                            {{ subskill.label }}
                        </div>
                    </div>
                </div>


            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SectionSkills',
    components: {
    },
    props : {
        section : { type : Object, required : true }
    },
    data : function() {
        return {

        }
    }
}
</script>

<style scoped>


</style>
